import { createSelector } from 'reselect'
import { Shared } from 'types/Shared'
import { getShared } from './helpers'

export const getNavArrivalsVariant = createSelector(
  [getShared],
  ({ navArrivalsVariant }: Shared): string | null => navArrivalsVariant ?? null
)
